export const SETUP_INTERCOM = 'intercom/SETUP_INTERCOM';
export const BOOTSTRAP_INTERCOM = 'intercom/BOOTSTRAP_INTERCOM';
export const SHUTDOWN_INTERCOM = 'intercom/SHUTDOWN_INTERCOM';
